module.exports = __webpack_public_path__ + "media/src/images/partners/heidelberg-8f8d0fc430199163f511b3aeee5af302.jpg";